import styled from 'styled-components';
import { colors, transition } from 'theme';

import { ButtonBase } from './ButtonBase';

export const PrimaryButton = styled(ButtonBase)`
  transition: all ${transition};
  text-decoration: none;
  ${(props) => `
    color: ${props.color || (props.reverse ? colors.waterBlue : colors.white)};
    background: ${
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line no-nested-ternary
      props.reverse
        ? colors.white
        : props.green
        ? colors.turtleGreen
        : colors.waterBlue
    };
  `}
  &:hover {
    background-color: ${(props) =>
      props.green ? colors.waterBlue : colors.turtleGreen};
    color: ${colors.white};
    text-decoration: none;
  }
  &:disabled {
    &:hover {
      background-color: ${colors.waterBlue};
    }
  }
`;
